import FenetresAide from 'enums/FenetresAide'

// [POST] /api/search/bien

export enum TypeBien {
  Maison = 0,
  Appartement = 1,
  Terrain = 2,
}

export interface APISearchBien {
  typeBien: number
  surfaceAuSol: null | {
    min: number
    max: number | null
  }
  piscine: boolean | null
  cityCode: string[] | null
  searchZone: {
    rayon: number
    centre: {
      latitude: number
      longitude: number
    }
  } | null
  aireParcelle: {
    min: number
    max: number | null
  }
  surfaceHabitable: null | {
    min: number
    max: number | null
  }
  batiMitoyen: boolean | null
}

// [POST] /api/search/dvf
export interface APISearchDVF {
  typeBien: number[]
  nombrePieces: number[]
  montantTransaction: {
    min: number
    max: number | null
  }
  dateTransaction: {
    min: Date | null
    max: Date | null
  }
  cityCode: string[] | null
  searchZone: {
    rayon: number
    centre: {
      latitude: number
      longitude: number
    }
  } | null
  aireParcelle: {
    min: number
    max: number | null
  }
  surfaceHabitable: {
    min: number
    max: number | null
  }
}

// [POST] /api/address/parcelles
export type APIAddressParcelle = {
  id: string
  lat: number
  lng: number
}[]

// [GET] /api/agent/codes-postaux/liste-insee

export interface APIListInsee {
  codeInsee: string
  nomCommune: string
  codesPostaux: string[]
}

// [GET] /api/me
export interface APIMe {
  name: string
  surname: string
  roles: string[]
  fenetresAide: { [key in FenetresAide]: boolean }
}
